<template>
  <div>
    <h1 class="page-header">{{ $t('scholarship.scholarship') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('scholarship.mainProgram') }}</label>
              <ts-search-select
                :disabled="updating"
                v-model.number="model.acp_id"
                :options="mainPrograms"
                @change="onMainProgramChange"
              ></ts-search-select>
              <small
                ><i>{{
                  $t(
                    'scholarship.chooseanymainprogramstodisplaysubprogramsandgrading'
                  )
                }}</i></small
              >
            </div>
            <div class="form-group m-b-15">
              <label>
                {{ $t('scholarship.subProgram') }}
                <span class="text-danger">*</span>
                <i class="fas fa-spinner spin" v-if="main_program_change"></i>
              </label>
              <ts-search-select
                v-model.number="model.acps_id"
                :disabled="main_program_change || updating"
                :options="subPrograms"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label
                >{{ $t('scholarship.grading') }}
                <span class="text-danger">*</span>
                <i class="fas fa-spinner spin" v-if="main_program_change"></i>
              </label>
              <ts-search-select
                v-model.number="model.grade_definition_id"
                :disabled="main_program_change || updating"
                :options="grading"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('grade_definition_id')">
                {{ errors.first('grade_definition_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('scholarship.discount') }}</label>
              <input
                v-model.number="model.discount_rate"
                type="number"
                step="any"
                class="form-control"
                :class="{ 'is-invalid': errors.has('discount_rate') }"
                :placeholder="$t('scholarship.enterscholarshipdiscount')"
              />
              <div class="invalid-feedback" v-if="errors.has('discount_rate')">
                {{ errors.first('discount_rate') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('scholarship.description') }}</label>
              <textarea
                v-model.trim="model.description"
                rows="3"
                class="form-control"
                :placeholder="$t('scholarship.leaveyourdescriptionhere')"
              ></textarea>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table'
export default {
  name: 'scholarship-form',
  components: {
    DataTable
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      main_program_change: false,
      model: {
        acp_id: '',
        acps_id: '',
        grade_definition_id: '',
        discount_rate: '',
        description: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('scholarship', ['edit_data']),
    mainPrograms() {
      return this.$store.state.scholarship.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subPrograms() {
      return this.$store.state.scholarship.sub_programs.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    },
    grading() {
      return this.$store.state.scholarship.grading.map(el => ({
        value: el.grade_definition_id,
        text: el.grade
      }))
    }
  },
  methods: {
    async onMainProgramChange() {
      if (!this.model.acp_id) {
        this.main_program_change = false
        return
      }
      this.main_program_change = true
      await this.$store.dispatch('scholarship/getSubProgram', this.model.acp_id)
      await this.$store.dispatch('scholarship/getGrading', this.model.acp_id)
      this.main_program_change = false
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('scholarship/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('scholarship/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('scholarship/SET_EDIT_DATA', {})
      this.$router.push({ name: 'scholarship' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('scholarship/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.main_program_change = true
        await this.$store.dispatch(
          'scholarship/getSubProgram',
          this.edit_data.acp_id
        )
        await this.$store.dispatch(
          'scholarship/getGrading',
          this.edit_data.acp_id
        )
        this.model = _.clone(this.edit_data)
        this.updating = true
        this.main_program_change = false
      }
    },
    clearInput() {
      this.model = {
        acp_id: '',
        acps_id: '',
        grade_definition_id: '',
        discount_rate: '',
        description: ''
      }
    }
  },
  watch: {
    edit_data: {
      async handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('scholarship/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
